import React from "react";

function Missing() {
  return <div>404 page not found </div>;
}

export default Missing;
